import { connect } from 'react-redux';

import ListsCreateEditDummyModal from './list-create-edit-modal/ListCreateEditDummyModal';

import { saveList } from 'modules/lists/reducers/lists';

import type { ListMeta } from 'types';

const mapDispatchToProps = (dispatch) => ({
  dispatchSaveList: (list: ListMeta, organizationId: number, listId?: number | null, shouldUpdate?: boolean | null) =>
    dispatch(saveList(list, organizationId, listId ?? undefined, shouldUpdate ?? false))
});

export default connect(undefined, mapDispatchToProps)(ListsCreateEditDummyModal);
